import {Advertisement} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/advertisement.types';

interface AdvertisementTile {
  image: {
    url: string;
    description: string;
    external: boolean;
  };
  targetUrl: string | undefined;
  id: number;
  promotionTracking:
    | {
        id: string;
        name: string;
      }
    | undefined;
  basInfoIconLink?: string;
}

export type NullableAdvertisementTile = AdvertisementTile | null;

export const convertAdvertisementToTile = (
  advertisement: Advertisement,
): NullableAdvertisementTile => {
  const {image, target, targetUrl, promotionTracking, infoIcon} = advertisement;
  if (!image) {
    return null;
  }

  let id = NaN;

  switch (target?.$case) {
    case 'brand':
      id = target.brand.id;
      break;
    case 'outfit':
      id = target.outfit.id;
      break;
    case 'story':
      id = target.story.id;
      break;
    default:
      break;
  }

  return {
    image: image!,
    targetUrl: targetUrl?.url,
    id,
    promotionTracking,
    basInfoIconLink: infoIcon?.cta?.linkTarget.url,
  };
};
